import { Building2, ClipboardList, FileText, FolderOpen } from 'lucide-react';
import type { GlobalSearchHit } from '@/api/endpoints/search';

/** Icon per global-search hit type, shared by the Search page and the header preview. */
export const GLOBAL_SEARCH_TYPE_ICONS: Record<
  GlobalSearchHit['type'],
  React.ComponentType<{ className?: string }>
> = {
  building: Building2,
  report: FileText,
  request: ClipboardList,
  vault: FolderOpen,
};

/** Label per global-search hit type. */
export const GLOBAL_SEARCH_TYPE_LABELS: Record<GlobalSearchHit['type'], string> = {
  building: 'Property',
  report: 'Report',
  request: 'Work Order',
  vault: 'Drawing Vault',
};
